import router from "next/router"

/**
 * Navigate to trade page with optional symbol search parameter
 * @param symbol - Optional symbol to set for trading (e.g., 'BTC', 'ETH')
 */
export function navigateToTrade(symbol?: string) {
  if (symbol && symbol.trim() !== '') {
    router.push(`/(tabs)/trade?symbol=${symbol.trim()}`)
  } else {
    router.push('/(tabs)/trade')
  }
}

/**
 * Navigate to trade page and set symbol for trading
 * @param symbol - Symbol to set for trading (e.g., 'BTC', 'ETH')
 */
export function navigateToTradeWithSymbol(symbol: string) {
  if (!symbol || symbol.trim() === '') {
    console.warn('Invalid symbol provided to navigation, falling back to default trade page')
    router.push('/(tabs)/trade')
    return
  }
  router.push(`/(tabs)/trade?symbol=${symbol.trim()}`)
}